import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import FuelDatasetTab from './FuelDatasetTab';
import CpiDatasetTab from './CpiDatasetTab';
import HocDatasetTab from './HocDatasetTab';
import './DatasetsTab.scss';

interface SessionTokens {
  jwtToken: string;
  sessionId: string;
}

interface DatasetsTabProps {
  getSessionTokensFn: () => Promise<SessionTokens>;
}

type DatasetKey = 'fuel' | 'cpi' | 'hoc';

const SUB_TABS: { key: DatasetKey; label: string }[] = [
  { key: 'fuel', label: 'Fuel' },
  { key: 'cpi', label: 'CPI' },
  { key: 'hoc', label: 'HOC' },
];

const DatasetsTab: FC<DatasetsTabProps> = ({ getSessionTokensFn }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const dsParam = searchParams.get('ds');
  const active: DatasetKey = dsParam === 'cpi' || dsParam === 'hoc' ? dsParam : 'fuel';

  const handleSubTab = (key: DatasetKey) => {
    const params = new URLSearchParams(searchParams);
    params.set('tab', 'datasets');
    params.set('ds', key);
    setSearchParams(params);
  };

  return (
    <div className="datasets-tab">
      <div className="datasets-tab__sub-tab-bar">
        {SUB_TABS.map((st) => (
          <button
            key={st.key}
            type="button"
            className={`datasets-tab__sub-tab ${
              active === st.key ? 'datasets-tab__sub-tab--active' : ''
            }`}
            onClick={() => handleSubTab(st.key)}
          >
            {st.label}
          </button>
        ))}
      </div>

      {active === 'fuel' && <FuelDatasetTab getSessionTokensFn={getSessionTokensFn} />}
      {active === 'cpi' && <CpiDatasetTab getSessionTokensFn={getSessionTokensFn} />}
      {active === 'hoc' && <HocDatasetTab getSessionTokensFn={getSessionTokensFn} />}
    </div>
  );
};

export default DatasetsTab;
